import { required, minLength, regex } from 'react-admin'

export const validateTextField = [required(), minLength(3)]
export const validateBaseUrl = regex(
  /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/,
  'Неверный url'
)
